/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserBrandingResponse
 */
export interface GetUserBrandingResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentAvatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentMlsId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    agentPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    officeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    officeLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    teamName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    teamLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    instagramUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    facebookUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    xUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    youtubeUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBrandingResponse
     */
    linkedInUrl?: string | null;
}

/**
 * Check if a given object implements the GetUserBrandingResponse interface.
 */
export function instanceOfGetUserBrandingResponse(value: object): value is GetUserBrandingResponse {
    return true;
}

export function GetUserBrandingResponseFromJSON(json: any): GetUserBrandingResponse {
    return GetUserBrandingResponseFromJSONTyped(json, false);
}

export function GetUserBrandingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserBrandingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'agentName': json['agentName'] == null ? undefined : json['agentName'],
        'agentEmail': json['agentEmail'] == null ? undefined : json['agentEmail'],
        'agentTitle': json['agentTitle'] == null ? undefined : json['agentTitle'],
        'agentAvatar': json['agentAvatar'] == null ? undefined : json['agentAvatar'],
        'agentMlsId': json['agentMlsId'] == null ? undefined : json['agentMlsId'],
        'agentPhoneNumber': json['agentPhoneNumber'] == null ? undefined : json['agentPhoneNumber'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'officeLogo': json['officeLogo'] == null ? undefined : json['officeLogo'],
        'website': json['website'] == null ? undefined : json['website'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'teamLogo': json['teamLogo'] == null ? undefined : json['teamLogo'],
        'instagramUrl': json['instagramUrl'] == null ? undefined : json['instagramUrl'],
        'facebookUrl': json['facebookUrl'] == null ? undefined : json['facebookUrl'],
        'xUrl': json['xUrl'] == null ? undefined : json['xUrl'],
        'youtubeUrl': json['youtubeUrl'] == null ? undefined : json['youtubeUrl'],
        'linkedInUrl': json['linkedInUrl'] == null ? undefined : json['linkedInUrl'],
    };
}

export function GetUserBrandingResponseToJSON(json: any): GetUserBrandingResponse {
    return GetUserBrandingResponseToJSONTyped(json, false);
}

export function GetUserBrandingResponseToJSONTyped(value?: GetUserBrandingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'agentName': value['agentName'],
        'agentEmail': value['agentEmail'],
        'agentTitle': value['agentTitle'],
        'agentAvatar': value['agentAvatar'],
        'agentMlsId': value['agentMlsId'],
        'agentPhoneNumber': value['agentPhoneNumber'],
        'officeName': value['officeName'],
        'officeLogo': value['officeLogo'],
        'website': value['website'],
        'teamName': value['teamName'],
        'teamLogo': value['teamLogo'],
        'instagramUrl': value['instagramUrl'],
        'facebookUrl': value['facebookUrl'],
        'xUrl': value['xUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'linkedInUrl': value['linkedInUrl'],
    };
}

